import React from 'react';
import tpl from '../templates/InsuranceTour';
import BaseNewCardView from './../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            tab: 'insurer-info',
            tabShortInsuranceInfo: 'univers-short',
            tabFullInsuranceInfo: 'univers-full',
            detailedInfoUniversWidget: (ssrData && ssrData.detailedInfoUniversWidget) || [],
            detailedInfoUniversWidget_loading: !(ssrData && ssrData.detailedInfoUniversWidget),
            detailedInfoTasWidget: (ssrData && ssrData.detailedInfoTasWidget) || [],
            detailedInfoTasWidget_loading: !(ssrData && ssrData.detailedInfoTasWidget),
            detailedInfoVusoWidget: (ssrData && ssrData.detailedInfoVusoWidget) || [],
            detailedInfoVusoWidget_loading: !(ssrData && ssrData.detailedInfoVusoWidget),
            detailedInfoArxWidget: (ssrData && ssrData.detailedInfoArxWidget) || [],
            detailedInfoArxWidget_loading: !(ssrData && ssrData.detailedInfoArxWidget),
            detailedInfoEvroinsWidget: (ssrData && ssrData.detailedInfoEvroinsWidget) || [],
            detailedInfoEvroinsWidget_loading: !(ssrData && ssrData.detailedInfoEvroinsWidget),
            detailedInfoUniqaWidget: (ssrData && ssrData.detailedInfoUniqaWidget) || [],
            detailedInfoUniqaWidget_loading: !(ssrData && ssrData.detailedInfoUniqaWidget),
            detailedInfoTaslifeWidget: (ssrData && ssrData.detailedInfoTaslifeWidget) || [],
            detailedInfoTaslifeWidget_loading: !(ssrData && ssrData.detailedInfoTaslifeWidget),
            detailedInfoEtsWidget: (ssrData && ssrData.detailedInfoEtsWidget) || [],
            detailedInfoEtsWidget_loading: !(ssrData && ssrData.detailedInfoEtsWidget),
            detailedInfoRespectWidget: (ssrData && ssrData.detailedInfoRespectWidget) || [],
            detailedInfoRespectWidget_loading: !(ssrData && ssrData.detailedInfoRespectWidget),
            detailedInfoPzuWidget: (ssrData && ssrData.detailedInfoPzuWidget) || [],
            detailedInfoPzuWidget_loading: !(ssrData && ssrData.detailedInfoPzuWidget)
        };
    }

    toggleShortInsuranceInfoTab = tab => {
        this.setState({tabShortInsuranceInfo: tab});
    };

    toggleFullInsuranceInfoTab = tab => {
        this.setState({tabFullInsuranceInfo: tab});
    };

    componentDidMount() {
        super.componentDidMount();
        const widgets = [
            {path: '/services/insurance_tour_univers', widgetKey: 'detailedInfoUniversWidget'},
            {path: '/services/insurance_tour_tas', widgetKey: 'detailedInfoTasWidget'},
            {path: '/services/insurance_tour_vuso', widgetKey: 'detailedInfoVusoWidget'},
            {path: '/services/insurance_tour_arx', widgetKey: 'detailedInfoArxWidget'},
            {path: '/services/insurance_tour_evroins', widgetKey: 'detailedInfoEvroinsWidget'},
            {path: '/services/insurance_tour_uniqa', widgetKey: 'detailedInfoUniqaWidget'},
            {path: '/services/insurance_tour_taslife', widgetKey: 'detailedInfoTaslifeWidget'},
            {path: '/services/insurance_tour_ets', widgetKey: 'detailedInfoEtsWidget'},
            {path: '/services/insurance_tour_respect', widgetKey: 'detailedInfoRespectWidget'},
            {path: '/services/insurance_tour_pzu', widgetKey: 'detailedInfoPzuWidget'}
        ];
        widgets.forEach(({path, widgetKey}) => {
            if (this.state[`${widgetKey}_loading`]) {
                this.widgetsHelper.getWidgetsByPath.call(this, {path, widgetKey});
            }
        });
    }

    static displayName = 'InsuranceTour';
}
